import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import compose from 'recompose/compose';

// Material helpersimport { forwardRef } from 'react';
import { forwardRef } from 'react';
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
//
import { getDataMaintenance } from '../../../services/getMaintenance'
import { updateMaintenance } from '../../../services/createMaintenance'
import { updateMarkePeriod } from '../../../services/markedPeriod';
import { deleteMarkePeriod } from '../../../services/markedPeriod';
import { MaterialTableExportAction } from '../../../components/MaterialTableExportAction';
import { MaterialTableExportToolbar, EXPORT_ACTION_NAME } from '../../../components/MaterialTableExportToolbar';
import { buildCsvFromObjects } from '../../../utils/fns/build-csv-rows';
import { generateCsv } from '../../../utils/fns/generate-csv';
// Component styles
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

// definido a nivel de modulo para que la identidad no cambie entre renders y no se remonte el toolbar
const tableComponents = {
  Action: MaterialTableExportAction,
  Toolbar: MaterialTableExportToolbar
};

function buildExportData(rows, t) {
  const headers = {
    usuario: t('history.columns.usuario'),
    inicio: t('history.columns.inicio'),
    termino: t('history.columns.termino'),
    estado: t('history.columns.estado'),
    titulo: t('history.columns.titulo'),
    comentario: t('history.columns.comentario'),
    objetivos: t('history.columns.objetivos'),
  };
  const statusLabels = t('history.status.option', { returnObjects: true }) || {};

  return rows.map((row) => ({
    [headers.usuario]: row.usuario,
    [headers.inicio]: row.start,
    [headers.termino]: row.end,
    [headers.estado]: statusLabels[row.estado] ?? row.estado,
    [headers.titulo]: row.title,
    [headers.comentario]: row.comentario,
    [headers.objetivos]: row.objetivos,
  }));
}

class History extends Component {
    constructor(props) {
        super(props);
        //this.myCallback = this.myCallback.bind(this);
        this.state = {
            load:true,
            begin:moment().subtract(6,'days'),
            listData:[],
            dialogOpen:false,
            row: {
              user: '',
              begin: '',
              final: '',
              titulo: '',
              comentario: '',
              usuario_id:'',
              editable: '',
              periodoMarcado: '',
              objId: '', 
              nodoId: ''
            },
            dialogOpenMsg:false,
            msg:'',
            dialogOpenMsgDelete: false,
            rowToDelete: null,
            snackbar: {
              open: false,
              message: '',
              severity: 'info' // 'success', 'error', 'warning', 'info'
            },
        }
    }

    componentDidMount() {
        this.getDataFromAPI();
      }

    // material-table resetea tableData.groupOrder cada vez que recibe columnas nuevas,
    // asi que reusamos el mismo array mientras no cambie el idioma para no perder la agrupacion
    getColumns() {
      const { t, i18n } = this.props;
      const language = i18n ? i18n.language : 'es';

      if (!this.columns || this.columnsLang !== language) {
        this.columnsLang = language;
        this.columns = [
          { title: t ? t('history.columns.usuario') : 'Usuario', field: "usuario" },
          { title: t ? t('history.columns.inicio') : 'Inicio mantenimiento', field: "start" },
          { title: t ? t('history.columns.termino') : 'Término mantenimiento', field: "end" },
          { title: t ? t('history.columns.estado') : 'Estado', field: "estado", render: rowData => {
            return(<span style={{fontSize: '10px', backgroundColor: '#eee', padding: '2px 4px', borderRadius: '4px', border: '1px solid '+rowData.backgroundColor }}>
              {t('history.status.option', {returnObjects: true})?.[rowData.estado] ?? rowData.estado}
              </span>
          )}},
          { title: t ? t('history.columns.titulo') : 'Título', field: "title" },
          { title: t ? t('history.columns.comentario') : 'Comentario', field: "comentario" },
          { title: t ? t('history.columns.objetivos') : 'Objetivos', field: "objetivos" },
        ];
      }

      return this.columns;
    }
    handleCloseModal = event => {   
      this.setState({
          dialogOpen: false,  
      })
    };
    handleCloseModalMsg = event => {   
      this.setState({
          dialogOpenMsg: false,  
          msg:''
      })
    };
  
    getDataFromAPI(){
      let token = sessionStorage.getItem('key')
      let user = sessionStorage.getItem('user')
      let client = sessionStorage.getItem('client_id')
      let objetivos = JSON.parse(sessionStorage.getItem('listaObjetivosOnline'));
      const {begin}=this.state
      var date=begin.format('YYYY-MM-DD')
      var newObjetivos=(objetivos.map(ele=>ele.objetivo_id))
      getDataMaintenance(client, token, date, user, newObjetivos, 1).then(data=>{
        try {
          this.processData(data)   
                  
        } catch (error) {
            this.setState({
                dataError: true,
                load: false
            });
        }
      })     
    }
    processData(data){
      var listObjectives=JSON.parse(sessionStorage.getItem("listaObjetivosOnline"))
      let user = sessionStorage.getItem('user');
      let admin = sessionStorage.getItem('admin_id');
      var NewData=[]
      var dict={}
      data.map(ele=>{
          var begin=moment(ele.fecha_inicio).format("YYYY-MM-DD HH:mm:SS")
          var final=moment(ele.fecha_termino).format("YYYY-MM-DD HH:mm:SS")
          const periodoMarcado = Boolean(ele.periodo_marcado_id);
          const editable = ele.estado?.toLowerCase() === 'ingresado' && 
                      (parseInt(user) === parseInt(ele.usuario_id) || Boolean(admin));
          var backgroundColor = ele.backgroundColor
          dict={'id':ele.id,'usuario_id':ele.usuario_id,'usuario':ele.nombre,"start":begin,"end":final,'comentario':ele.comentario,
            'estado':ele.estado, "title":ele.titulo,"editable":editable, "periodoMarcado":periodoMarcado, "backgroundColor":backgroundColor,
            "admin": admin,"objId": ele.objetivo_id, "nodoId":ele.nodos_id}
          var strObj=""
          var dictOk=false
          ele.objetivos.map((obj, i)=>{
            if(listObjectives.filter(j=>j.objetivo_id==ele.objetivo_id[i]).length>0){
              dictOk=true
              if(i+1!==ele.objetivos.length){
                strObj+=obj["nombre"]+', '
              }else{
                strObj+=obj["nombre"]
              }
            }
            
          })
          dict["objetivos"]=strObj
          if(dictOk){
            NewData.push(dict) 
          }
          
      })
      NewData.sort(function (a, b) {
        return (moment(b.start)-moment(a.start));
      });
      this.setState({
        load: false,
        listData:NewData
      });
    }
    edit=(row)=>{
       this.setState({
            row: {
              id: row.id,
              user: row.usuario || '',
              begin: moment(row.start).format('YYYY-MM-DD HH:mm'),
              final: moment(row.realEnd || row.end).format('YYYY-MM-DD HH:mm'),
              titulo: row.title || '',
              comentario: row.comentario || '',
              usuario_id: row.usuario_id,
              editable: row.editable,
              periodoMarcado: row.periodoMarcado,
              objId: row.objId, 
              nodoId:row.nodoId
            },
            dialogOpen:true,
          });
    }
    remove=(dataRow)=>{
      let token = sessionStorage.getItem('key')
      let id_user = sessionStorage.getItem('user')
      const { t } = this.props;
      if(dataRow.periodoMarcado){
        deleteMarkePeriod({dataRow}).then(response=>{
          if(response.status !== 200){
            this.showNotification(
              t ? t('history.msg.updateFailed') : 'No fue posible llevar a cabo la modificación',
              'error'
            );
          }else{
            this.showNotification(
              t ? t('history.msg.updateSuccess') : 'Cambio exitoso',
              'success'
            );
        }})
      }else{
        updateMaintenance(dataRow.id, id_user, token, dataRow.comentario, dataRow.title, 'Cancelado').then(data=>{
          if(data===false){
            this.showNotification(
              t ? t('history.msg.updateFailed') : 'No fue posible llevar a cabo la modificación',
              'error'
            );
          }else{
            this.showNotification(
              t ? t('history.msg.updateSuccess') : 'Cambio exitoso',
              'success'
            );
          }
        })
      }
    }

    handleFieldChange = (field, value) => {
      this.setState(prevState => ({
        row: {
          ...prevState.row,
          [field]: value
        }
      }));
    };

    handleSaved = async (value) => {
      const {row}=this.state
      const { t } = this.props;
      let token = sessionStorage.getItem('key')
      let id_user = sessionStorage.getItem('user')
      let timezone = sessionStorage.getItem('tz')
      let admin = sessionStorage.getItem('admin_id');
      if(row.periodoMarcado){
        var begin=moment(row.start).format("YYYY-MM-DD HH:mm:SS")
        var final=moment(row.end).format("YYYY-MM-DD HH:mm:SS")
        updateMarkePeriod({periodo_marcado_id: row.id,
                                    fecha_inicio: begin,
                                    fecha_termino: final,
                                    motivo: row.titulo,
                                    tz: timezone,
                                    usuario: admin,
                                    objId: row.objId,
                                    nodoId: row.nodoId
                                }).then(response=>{
                                    if(response.status !== 200){
                                      this.showNotification(
                                        t ? t('history.msg.updateFailed') : 'No fue posible llevar a cabo la modificación',
                                        'error'
                                      );
                                    }else{
                                      this.showNotification(
                                        t ? t('history.msg.updateSuccess') : 'Cambio exitoso',
                                        'success'
                                      );
                                }})
      }else{
        updateMaintenance(row.id, id_user, token, row.comentario, row.titulo, null).then(data=>{
          if(data===false){
            this.showNotification(
              t ? t('history.msg.updateFailed') : 'No fue posible llevar a cabo la modificación',
              'error'
            );
          }else{
            this.showNotification(
              t ? t('history.msg.updateSuccess') : 'Cambio exitoso',
              'success'
            );
          }
        })
      }      
    }

    // Función auxiliar para activar el snackbar
  showNotification = (msg, severity) => {
    this.setState({
      snackbar: {
        open: true,
        message: msg,
        severity: severity
      }
    });
  };

  handleCloseSnackbar = () => {
    this.setState(prev => ({ snackbar: { ...prev.snackbar, open: false } }));
  };

    render() {
    const {listData, load, dialogOpen, row, msg, dialogOpenMsg, dialogOpenMsgDelete, rowToDelete, snackbar }=this.state
    const isDateError = row.begin && row.final && new Date(row.final) <= new Date(row.begin);
    const { t } = this.props;
        if(load===true){
          return(
            <Card >
              <PerfectScrollbar>
                  <Typography
                      
                      variant="h5"
                      align="center">
                      <CircularProgress
                          variant="indeterminate"      
                          size={24}
                          thickness={4}                            
                      />
                      {t ? t('history.loading') : 'Cargando Información...'}
                      </Typography>
              </PerfectScrollbar>
            </Card>
          )
        }else{
          return (
            <Card >
              <Snackbar 
                  open={snackbar.open} 
                  autoHideDuration={5000} 
                  onClose={this.handleCloseSnackbar}
                  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                  <MuiAlert 
                    elevation={6} 
                    variant="filled" 
                    severity={snackbar.severity} 
                    onClose={this.handleCloseSnackbar}
                  >
                    {snackbar.message}
                  </MuiAlert>
                </Snackbar>
                <MaterialTable
                    icons={tableIcons}
                    columns={this.getColumns()}
                    data={listData}
                    components={tableComponents}
                    actions={[
                      {
                        name: EXPORT_ACTION_NAME,
                        icon: () => <SaveAlt fontSize="small" />,
                        tooltip: t ? t('history.actions.downloadCsv') : 'Descargar CSV',
                        disabledTooltip: {
                          grouped: t ? t('history.actions.downloadCsvGrouped') : 'Desagrupe la tabla para poder descargar',
                          empty: t ? t('history.actions.downloadCsvEmpty') : 'No hay datos para descargar',
                        },
                        isFreeAction: true,
                        onClick: (rows) => generateCsv({
                          name: `${t ? t('history.exportFilename') : 'historial_mantenimientos'}.csv`,
                          data: buildCsvFromObjects(buildExportData(rows, t)),
                        }),
                      },
                      rowData => ({
                        icon: ()=><Edit/>,
                        tooltip: t ? t('history.actions.edit') : 'Editar mantenimiento',
                        onClick: (event, rowData) => this.edit( rowData),
                        disabled: !rowData.editable,
                      }),
                      rowData => ({
                        icon: ()=><Remove/>,
                        tooltip: t ? t('history.actions.delete') : 'Eliminar mantenimiento',
                        onClick: (event) => this.setState({ dialogOpenMsgDelete: true, rowToDelete: rowData }),
                        //onClick: (event, rowData) => this.remove( rowData),
                        disabled: !rowData.editable,
                      })
                    ]}
                    title=""
                    localization={{
                      grouping: {
                        groupedBy: t ? t('history.grouping.groupedBy') : 'Agrupar por:',
                        placeholder: t ? t('history.grouping.placeholder') : 'Arrastre los encabezados aquí, para agrupar',
                      },
                      body: {
                      emptyDataSourceMessage: t ? t('history.body.empty') : 'No hay datos'
                      },
                      toolbar: {
                      searchTooltip: t ? t('history.toolbar.searchTooltip') : 'Buscar'
                      },
                      pagination: {
                      labelRowsSelect: t ? t('history.pagination.labelRowsSelect') : 'Filas',
                      labelDisplayedRows: t ? t('history.pagination.labelDisplayedRows') : ' {from}-{to} de {count}',
                      firstTooltip: t ? t('history.pagination.firstTooltip') : 'Pri. pág.',
                      previousTooltip: t ? t('history.pagination.previousTooltip') : 'Pág. previa',
                      nextTooltip: t ? t('history.pagination.nextTooltip') : 'Sig. pág.',
                      lastTooltip: t ? t('history.pagination.lastTooltip') : 'Últ. pág'
                      },
                      header: {
                        actions: t ? t('history.header.actions') : 'Acciones'
                      }
                    }}
                    options={{
                        grouping: true
                    }}
                >
                  
                </MaterialTable>
                <Modal
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                  open={dialogOpen}
                  onClose={this.handleCloseModal}
                  style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                  }}
                  disableAutoFocus={true}
                  disableEnforceFocus={true}
                  closeAfterTransition
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                      timeout: 500,
                  }}
              >                                    
                  <Fade in={dialogOpen}>
                  <Grid
                      item
                      xs={2}
                      sm={2}
                      md={2}
                      xl={2}
                      container
                      spacing={3}
                      style={{backgroundColor:"white"}}
                  >
                      <Grid style={{textAlign:"right"}} >
                          <IconButton style={{textAlign:"right",color:'black'}}   onClick={this.handleCloseModal}><CloseIcon/></IconButton>
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                        <TextField
                          //helperText="Nombre"
                          label={t ? t('history.modal.label.nombre') : 'nombre'}
                          margin="dense"
                          onChange={event =>
                              this.handleFieldChange('name', event.target.value)
                          }
                          required
                          value={row.user}
                          disabled 
                          id="standard-disabled"
                          //variant="outlined"
                      />
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                        <TextField
                            label={t ? t('history.modal.label.inicio') : 'inicio'}
                            margin="dense"
                            onChange={event => {
                              const rawValue = event.target.value;
                              // Validamos que el usuario haya seleccionado una fecha completa antes de formatear
                              const formattedValue = rawValue ? moment(rawValue).format("YYYY-MM-DD HH:mm:ss") : "";
                              
                              this.handleFieldChange('begin', formattedValue);
                            }}
                            type="datetime-local"
                            required
                            value={row.begin ? moment(row.begin).format("YYYY-MM-DDTHH:mm") : ""}
                            //disabled={!row.periodoMarcado}
                            disabled
                            id="standard-disabled"
                        />
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                        <TextField
                            label={t ? t('history.modal.label.termino') : 'termino'}
                            margin="dense"
                            onChange={event => {
                              const rawValue = event.target.value;
                              // Validamos que el usuario haya seleccionado una fecha completa antes de formatear
                              const formattedValue = rawValue ? moment(rawValue).format("YYYY-MM-DD HH:mm:ss") : "";
                              
                              this.handleFieldChange('final', formattedValue);
                            }}
                           
                            type="datetime-local"
                            required
                            value={row.final ? moment(row.final).format("YYYY-MM-DDTHH:mm") : ""}
                            //disabled={!row.periodoMarcado}
                            disabled
                            id="standard-disabled"
                            // Si hay error, se pone en rojo y muestra el mensaje
                            error={isDateError}
                            helperText={isDateError ? (t ? t('history.helperText.isDateError') : "La fecha de término debe ser posterior al inicio") : ""}
                            // Atributo nativo para que el calendario del navegador no deje elegir fechas anteriores
                            inputProps={{ min: row.begin }}
                        />
                      </Grid>
                      
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                      <TextField
                          //helperText="Nombre"
                          label={t ? t('history.modal.label.titulo') : 'titulo'}
                          margin="dense"
                          onChange={event =>
                              this.handleFieldChange('titulo', event.target.value)
                          }
                          required
                          value={row.titulo}
                          //variant="outlined"
                      />
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                      <TextField
                          //helperText="Nombre"
                          label={t ? t('history.modal.label.comentario') : 'comentario'}
                          margin="dense"
                          onChange={event =>
                              this.handleFieldChange('comentario', event.target.value)
                          }
                          required
                          value={row.comentario}
                          disabled={row.periodoMarcado}
                          //variant="outlined"
                      />
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          xl={12}
                          style={{textAlign:"center"}}
                      >
                        <Button
                          onClick={this.handleSaved}
                          color="primary"
                          variant="contained"
                          disabled={isDateError || !row.begin || !row.final}
                          
                        >
                            {t ? t('history.modal.save') : 'Guardar Mantenimiento'}
                        </Button>
                      </Grid>
                    </Grid>
                </Fade>
              </Modal>
              <Dialog
                open={dialogOpenMsgDelete}
                onClose={() => this.setState({ dialogOpenMsgDelete: false, rowToDelete: null })}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {this.props.t ? this.props.t('history.dialog.confirmTitle') : '¿Confirmar eliminación?'}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {this.props.t 
                      ? this.props.t('history.dialog.confirmText') 
                      : '¿Está seguro de que desea eliminar este mantenimiento? Esta acción no se puede deshacer.'}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {/* Botón Cancelar */}
                  <Button 
                    onClick={() => this.setState({ dialogOpenMsgDelete: false, rowToDelete: null })} 
                    color="secondary"
                  >
                    {this.props.t ? this.props.t('history.dialog.cancel') : 'Cancelar'}
                  </Button>
                  
                  {/* Botón Confirmar */}
                  <Button 
                    onClick={() => {
                      // Ejecutamos tu función remove pasando la fila guardada
                      this.remove(rowToDelete);
                      // Cerramos el diálogo
                      this.setState({ dialogOpenMsgDelete: false, rowToDelete: null });
                    }} 
                    color="primary"
                    variant="contained"
                    autoFocus
                  >
                    {this.props.t ? this.props.t('history.dialog.confirm') : 'Eliminar'}
                  </Button>
                </DialogActions>
              </Dialog>  
            </Card>
              
          );
      }
    }
}


export default compose(withWidth(), withStyles(styles), withTranslation())(History);
